import type { APIInstance } from "@/services/apiService";

export class CaseErrorsService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async resolveAll(caseId: string): Promise<void> {
    await this.api.put(`/cases/${caseId}/resolve-errors`);
  }
}
